class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {

    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.isDesktopQuery = window.matchMedia('(min-width: 750px)');
    this.onMouseEnterBound = this.onMouseEnter.bind(this);
    this.onMouseLeaveBound = this.onMouseLeave.bind(this);
    this.onSummaryPointerDownBound = this.onSummaryPointerDown.bind(this);
    this.onSummaryClickBound = this.onSummaryClick.bind(this);
    this.addEventListener('mouseenter', this.onMouseEnterBound);
    this.addEventListener('mouseleave', this.onMouseLeaveBound);
    this.summary.addEventListener('pointerdown', this.onSummaryPointerDownBound);
    this.summary.addEventListener('click', this.onSummaryClickBound);
    if (this.isDesktopQuery.addEventListener) {
      this.isDesktopQuery.addEventListener('change', (e) => {
        if (!e.matches) this.close();
      });
    }

    this.attachNestedSubmenuHover();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseEnter() {
    if (!this.isDesktopQuery.matches) return;
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', true);
      this.summary.setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    if (!this.isDesktopQuery.matches) return;
    this.close();
  }

  onSummaryPointerDown(e) {
    this.lastPointerType = e.pointerType;
  }

  onSummaryClick(e) {
    if (!this.isDesktopQuery.matches) return;
    if (this.lastPointerType === 'mouse' || this.lastPointerType === 'pen') {
      e.preventDefault();
    }
  }

  attachNestedSubmenuHover() {
    const nestedDetails = this.mainDetailsToggle.querySelectorAll('.header__submenu details');
    nestedDetails.forEach((detailEl) => {
      const nestedSummary = detailEl.querySelector('summary');
      if (!nestedSummary) return;

      const onEnter = () => {
        if (!this.isDesktopQuery.matches) return;
        if (!detailEl.hasAttribute('open')) {
          detailEl.setAttribute('open', true);
          nestedSummary.setAttribute('aria-expanded', true);
        }
      };

      const onLeave = () => {
        if (!this.isDesktopQuery.matches) return;
        detailEl.removeAttribute('open');
        nestedSummary.setAttribute('aria-expanded', false);
      };

      const onPointerDown = (e) => {
        detailEl._lastPointerType = e.pointerType;
      };

      const onClick = (e) => {
        if (!this.isDesktopQuery.matches) return;
        if (detailEl._lastPointerType === 'mouse' || detailEl._lastPointerType === 'pen') {
          e.preventDefault();
        }
      };

      detailEl.addEventListener('mouseenter', onEnter);
      detailEl.addEventListener('mouseleave', onLeave);
      nestedSummary.addEventListener('pointerdown', onPointerDown);
      nestedSummary.addEventListener('click', onClick);
    });
  }
}

customElements.define('header-menu', HeaderMenu);
